var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cmp cmp-method-list list mb-4",
      class: { error: _vm.showError },
    },
    [
      _c(
        "ul",
        {
          staticClass: "method-list component-loading",
          class: {
            "is-loading": _vm.isBasketLoading || _vm.isCheckoutReadonly,
          },
        },
        [
          _vm._l(_vm.methodOfPaymentList, function (paymentProvider) {
            return [
              paymentProvider.key !== _vm.klarnaPaymentKey
                ? _c(
                    "li",
                    {
                      staticClass: "method-list-item",
                      attrs: { "data-id": paymentProvider.id },
                    },
                    [
                      _c("input", {
                        attrs: {
                          type: "radio",
                          id: "paymentMethod" + _vm._uid + paymentProvider.id,
                          name: "MethodOfPaymentID" + _vm._uid,
                          disabled:
                            !paymentProvider.isSelectable ||
                            _vm.isCheckoutReadonly,
                        },
                        domProps: {
                          value: paymentProvider.id,
                          checked: _vm.methodOfPaymentId === paymentProvider.id,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.onPaymentProviderChange(paymentProvider)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.isPaymentMethodExcluded(
                                paymentProvider.id
                              ),
                              expression:
                                "isPaymentMethodExcluded(paymentProvider.id)",
                            },
                          ],
                          staticClass: "provider-select-label",
                          class: _vm.paddingClasses,
                          style: _vm.paddingInlineStyles,
                          attrs: {
                            for:
                              "paymentMethod" + _vm._uid + paymentProvider.id,
                            "data-toggle": "tooltip",
                            "data-placement": "top",
                            "data-title": _vm.$translate(
                              "Ceres::Template.checkoutChangeShippingProfileHint"
                            ),
                          },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              staticClass: "img-fluid",
                              attrs: {
                                src: paymentProvider.icon,
                                alt: paymentProvider.name,
                                title: paymentProvider.name,
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "d-inline-block w-100 text-center pl-1 pr-1",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(paymentProvider.name) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("popper", {
                        attrs: {
                          trigger: "hover",
                          placement: "bottom",
                          "body-class":
                            paymentProvider.sourceUrl ||
                            _vm.getDescription(paymentProvider)
                              ? ""
                              : "d-none",
                          "close-mouse-out": !paymentProvider.sourceUrl,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "handle",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "checkout__popover" },
                                    [_vm._v("i")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(paymentProvider.name) +
                                      "\n                    "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  paymentProvider.sourceUrl
                                    ? _c(
                                        "div",
                                        { staticClass: "float-right" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: paymentProvider.sourceUrl,
                                                rel: "noopener noreferrer",
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-external-link",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.checkoutPaymentMethodDetailsLink"
                                                    )
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.getDescription(paymentProvider)
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm.klarnaPayment
            ? _c(
                "li",
                {
                  staticClass: "method-list-item",
                  attrs: { "data-id": _vm.klarnaPayment.id },
                },
                [
                  _c("input", {
                    attrs: {
                      type: "radio",
                      id: "paymentMethod" + _vm._uid + _vm.klarnaPayment.id,
                      name: "MethodOfPaymentID" + _vm._uid,
                      disabled:
                        !_vm.klarnaPayment.isSelectable ||
                        _vm.isCheckoutReadonly,
                    },
                    domProps: {
                      value: _vm.klarnaPayment.id,
                      checked: _vm.methodOfPaymentId === _vm.klarnaPayment.id,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onPaymentProviderChange(_vm.klarnaPayment)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.isPaymentMethodExcluded(
                            _vm.klarnaPayment.id
                          ),
                          expression:
                            "isPaymentMethodExcluded(klarnaPayment.id)",
                        },
                      ],
                      staticClass: "provider-select-label",
                      class: _vm.paddingClasses,
                      style: _vm.paddingInlineStyles,
                      attrs: {
                        for: "paymentMethod" + _vm._uid + _vm.klarnaPayment.id,
                        "data-toggle": "tooltip",
                        "data-placement": "top",
                        "data-title": _vm.$translate(
                          "Ceres::Template.checkoutChangeShippingProfileHint"
                        ),
                      },
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: _vm.klarnaPayment.icon,
                            alt: _vm.klarnaPayment.name,
                            title: _vm.klarnaPayment.name,
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "d-inline-block w-100 text-center" },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.klarnaPayment.customName) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("popper", {
                    attrs: {
                      trigger: "hover",
                      placement: "bottom",
                      "body-class":
                        _vm.klarnaPayment.sourceUrl ||
                        _vm.klarnaPayment.customDescription
                          ? ""
                          : "d-none",
                      "close-mouse-out": !_vm.klarnaPayment.sourceUrl,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "handle",
                          fn: function () {
                            return [
                              _c("span", { staticClass: "checkout__popover" }, [
                                _vm._v("i"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.klarnaPayment.customName) +
                                  "\n                "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "content",
                          fn: function () {
                            return [
                              _vm.klarnaPayment.sourceUrl
                                ? _c("div", { staticClass: "float-right" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.klarnaPayment.sourceUrl,
                                          rel: "noopener noreferrer",
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-external-link",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.checkoutPaymentMethodDetailsLink"
                                              )
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.klarnaPayment.customDescription) +
                                  "\n                "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2534437900
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }